<template>
  <v-container fluid fill-height text-xs-center>
    <v-layout row wrap align-center justify-center>
      <v-flex xs10 offset-xs-1 sm10 offset-1 md5 offset-md-2 lg3 offset-lg-2>
        <v-card class="rounded">
          <div class="pa-3">
            <v-img
              :src="require('@/assets/img/logo-Ovation.v3.png')"
              contain
              height="120px"
            ></v-img>
          </div>
          <v-divider></v-divider>
          <v-card-text>
            <v-progress-linear
              color="#d13b55"
              height="2"
              indeterminate
            ></v-progress-linear>
            <div class="text-center title">Completing Authentication...</div>
          </v-card-text>
        </v-card>
        <div class="mt-2" style="text-align: right">
          <a @click="$store.dispatch('auth0Logout')" style="color: #d13b55"
            >Log Out &raquo;</a
          >
        </div>
      </v-flex>
    </v-layout>
    <div style="position: absolute; bottom: 50px; left: 50px; color: #888">
      <span>{{ $store.state.appVersion }}</span>
    </div>
  </v-container>
</template>

<script>
import axios from "axios";
import localStorageAuthTokenCheck from "@/plugins/localStorageAuthTokenCheck";

export default {
  name: "VerifyAuthentication",
  methods: {},
  beforeMount() {
    // If tokens are present - user is considered logged in (servies layer will verify tokens)
    if (localStorageAuthTokenCheck()) {
      // Verify the tokens by getting user profile
      axios
        .get("/api/user/self", this.$store.state.axiosConfig)
        .then((response) => {
          // Set the user as fully authenticated
          this.$store.commit("setuserIsAuthenticated", true);

          // Commit user info to global
          this.$store.commit("setUserSelf", response.data.user);

          // User profile may have be complete - dispatch for potential update to global flag
          this.$store.commit("refreshUserProfileIsComplete");

          // Check if profile has been created
          if (!this.$store.state.userProfileIsComplete) {
            // User profile is not complete - forward to new user wizard
            // User profile has NOT been completed
            this.$router.replace("/newuserwizard");
          } else {
            // User Profile is complete. Allow the user to route to desired location
            // Redirect -> get the saved url or redirect to dashboard otherwise
            let route = this.$store.state.verifyAuthenticationRedirectLocation;
            route = route ? route : "/dashboard"; // default to dashboard
            this.$router.replace(route);
          }
        })
        .catch((e) => {
          // check/ handle 401 (Unauthorized) error
          this.$store.dispatch("error401Response", e);

          // Display error message
          // ** Must set each property individually (ie can't set snackabar={prop:val, prop2:val2} or warnings happen)
        });
    }
    // Redirect to login page
    else {
      // Set the user as not being authenticated
      this.$store.commit("setuserIsAuthenticated", false);

      // Redirect to Login Page
      this.$router.replace("/login");
    }
  },
};
</script>
